module.exports = __webpack_public_path__ + "img/accessory_shirt_09.032b74fc.svg";